"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CataloguesLandingPageContainer = void 0;
var _auth = require("@ori/auth");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _presentationHttp = require("@ori/presentation-http");
var _testidGenerator = require("@ori/testid-generator");
var _components = require("../components");
var _constants = require("../constants");
var _constantsGenerated = require("../constants-generated");
var _contexts = require("../contexts");
var _logger2 = require("../logger");
var _ApiProvider = require("./ApiProvider");
var _jsxRuntime = require("react/jsx-runtime");
// istanbul ignore file -- No need to test passing of data to context.
const CataloguesLandingPageContainer = ()=>{
    const { tenant } = (0, _environment.useEnvironment)();
    const { language } = (0, _i18n.useLanguage)();
    const { customerId, token } = (0, _auth.useToken)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
        team: _testidGenerator.Team.Presentation,
        project: _constantsGenerated.APP_NAME,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
            logger: _logger2.mainLogger,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
                areaName: "CataloguesLandingPageContainer",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ApiProvider.ApiProvider, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
                        namespace: _constants.translationsNamespace,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationHttp.UserSegmentationDataProvider, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationHttp.HeadersProvider, {
                                customerId: customerId,
                                language: language,
                                sourceAppName: _constantsGenerated.PACKAGE_NAME,
                                tenant: tenant,
                                token: token,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_contexts.CataloguesLandingPageProvider, {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.CataloguesLandingPage, {})
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
exports.CataloguesLandingPageContainer = CataloguesLandingPageContainer;
